import React, { useEffect, useState } from 'react';
import { Button, Group, Text, Tooltip } from '@mantine/core';
import { IconMinus, IconPlus } from '@tabler/icons-react';
import { Tempo } from '@/javascript/music-objects';
import MidiPlayer from '@/javascript/midi-player';

interface TempoControlProps {
    initialTempo: Tempo;
    onTempoChange: (newTempo: Tempo) => void;
    isPhoneOrSmaller?: boolean;
}

const TempoControl: React.FC<TempoControlProps> = ({ initialTempo, onTempoChange, isPhoneOrSmaller }) => {
    const [tempo, setTempo] = useState(initialTempo);

    const handleNudge = (amount: number) => {
        const newBpm = tempo.getBpm() + amount;
        const newTempo = new Tempo(newBpm);
        setTempo(newTempo);
        onTempoChange(newTempo);
    };

    useEffect(() => {
        MidiPlayer.setTempo(initialTempo);
        setTempo(initialTempo);
    }, [initialTempo]);

    return (
        <Group
            align="center"
            gap="xs"
            wrap="nowrap"
        >
            <Tooltip label="Decrease BPM">
                <Button
                    size="compact-xs"
                    variant="light"
                    onClick={() => handleNudge(-5)}
                    disabled={tempo.getBpm() <= Tempo.MIN_BPM}
                >
                    <IconMinus size={isPhoneOrSmaller ? 12 : 16} />
                </Button>
            </Tooltip>

            <Text size="xs" style={{ minWidth: isPhoneOrSmaller ? 40 : 60, textAlign: 'center' }}>
                {tempo.getBpm()} BPM
            </Text>

            <Tooltip label="Increase BPM">
                <Button
                    size="compact-xs"
                    variant="light"
                    onClick={() => handleNudge(5)}
                    disabled={tempo.getBpm() >= Tempo.MAX_BPM}
                >
                    <IconPlus size={isPhoneOrSmaller ? 12 : 16} />
                </Button>
            </Tooltip>
        </Group>
    );
};

export default TempoControl;
